interface PracticeCountryTagProps {
    /** 'US' | 'CA' from the API, or null when the practice has no recognisable
     *  country on file. */
    country: string | null | undefined;
    className?: string;
}

/**
 * The practice's market, beside its name.
 *
 * Renders nothing when the country is unknown rather than guessing: the
 * backend's other normaliser (normalizeCountryToIso) defaults to 'US', which is
 * right for picking a price list and wrong for a label a human reads.
 */
function PracticeCountryTag({ country, className = '' }: PracticeCountryTagProps) {
    if (country !== 'US' && country !== 'CA') return null;

    return (
        <span
            title={country === 'CA' ? 'Canada' : 'United States'}
            className={`flex-shrink-0 text-[10px] font-semibold leading-none tracking-wide text-gray-500 border border-gray-300 rounded px-1 py-0.5 ${className}`}
        >
            {country}
        </span>
    );
}

export { PracticeCountryTag };
